/**
 * @fileoverview
 * @enhanceable
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var enums_pb = require('./enums_pb.js');
goog.exportSymbol('proto.UT.PROTO.OHLCV', null, global);
goog.exportSymbol('proto.UT.PROTO.OhlcDataRequest', null, global);
goog.exportSymbol('proto.UT.PROTO.OhlcDataResponse', null, global);
goog.exportSymbol('proto.UT.PROTO.Snapshot', null, global);
goog.exportSymbol('proto.UT.PROTO.SnapshotDataRequest', null, global);
goog.exportSymbol('proto.UT.PROTO.SnapshotDataResponse', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.OHLCV = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.OHLCV, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.OHLCV.displayName = 'proto.UT.PROTO.OHLCV';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.OHLCV.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.OHLCV.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.OHLCV} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.OHLCV.toObject = function(includeInstance, msg) {
  var f, obj = {
    open: jspb.Message.getFieldWithDefault(msg, 1, 0),
    close: jspb.Message.getFieldWithDefault(msg, 2, 0),
    high: jspb.Message.getFieldWithDefault(msg, 3, 0),
    low: jspb.Message.getFieldWithDefault(msg, 4, 0),
    volume: jspb.Message.getFieldWithDefault(msg, 5, 0),
    value: jspb.Message.getFieldWithDefault(msg, 6, 0),
    timestamp: jspb.Message.getFieldWithDefault(msg, 7, 0),
    fullCandle: jspb.Message.getFieldWithDefault(msg, 8, false),
    isMonthly: jspb.Message.getFieldWithDefault(msg, 9, false),
    isWeekly: jspb.Message.getFieldWithDefault(msg, 10, false),
    openInterest: jspb.Message.getFieldWithDefault(msg, 11, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.OHLCV}
 */
proto.UT.PROTO.OHLCV.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.OHLCV;
  return proto.UT.PROTO.OHLCV.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.OHLCV} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.OHLCV}
 */
proto.UT.PROTO.OHLCV.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpen(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setClose(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHigh(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLow(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setVolume(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFullCandle(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMonthly(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsWeekly(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOpenInterest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.OHLCV.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.OHLCV.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.OHLCV} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.OHLCV.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpen();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getClose();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getHigh();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getLow();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getVolume();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getFullCandle();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getIsMonthly();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getIsWeekly();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getOpenInterest();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
};


/**
 * optional int64 open = 1;
 * @return {number}
 */
proto.UT.PROTO.OHLCV.prototype.getOpen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.OHLCV.prototype.setOpen = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional int64 close = 2;
 * @return {number}
 */
proto.UT.PROTO.OHLCV.prototype.getClose = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.UT.PROTO.OHLCV.prototype.setClose = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional int64 high = 3;
 * @return {number}
 */
proto.UT.PROTO.OHLCV.prototype.getHigh = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.UT.PROTO.OHLCV.prototype.setHigh = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * optional int64 low = 4;
 * @return {number}
 */
proto.UT.PROTO.OHLCV.prototype.getLow = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.UT.PROTO.OHLCV.prototype.setLow = function(value) {
  jspb.Message.setField(this, 4, value);
};


/**
 * optional int64 volume = 5;
 * @return {number}
 */
proto.UT.PROTO.OHLCV.prototype.getVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.UT.PROTO.OHLCV.prototype.setVolume = function(value) {
  jspb.Message.setField(this, 5, value);
};


/**
 * optional int64 value = 6;
 * @return {number}
 */
proto.UT.PROTO.OHLCV.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.UT.PROTO.OHLCV.prototype.setValue = function(value) {
  jspb.Message.setField(this, 6, value);
};


/**
 * optional int64 timestamp = 7;
 * @return {number}
 */
proto.UT.PROTO.OHLCV.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.UT.PROTO.OHLCV.prototype.setTimestamp = function(value) {
  jspb.Message.setField(this, 7, value);
};


/**
 * optional bool full_candle = 8;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.UT.PROTO.OHLCV.prototype.getFullCandle = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 8, false));
};


/** @param {boolean} value */
proto.UT.PROTO.OHLCV.prototype.setFullCandle = function(value) {
  jspb.Message.setField(this, 8, value);
};


/**
 * optional bool is_monthly = 9;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.UT.PROTO.OHLCV.prototype.getIsMonthly = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 9, false));
};


/** @param {boolean} value */
proto.UT.PROTO.OHLCV.prototype.setIsMonthly = function(value) {
  jspb.Message.setField(this, 9, value);
};


/**
 * optional bool is_weekly = 10;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.UT.PROTO.OHLCV.prototype.getIsWeekly = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 10, false));
};


/** @param {boolean} value */
proto.UT.PROTO.OHLCV.prototype.setIsWeekly = function(value) {
  jspb.Message.setField(this, 10, value);
};


/**
 * optional int64 open_interest = 11;
 * @return {number}
 */
proto.UT.PROTO.OHLCV.prototype.getOpenInterest = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.UT.PROTO.OHLCV.prototype.setOpenInterest = function(value) {
  jspb.Message.setField(this, 11, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.OhlcDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.UT.PROTO.OhlcDataResponse.repeatedFields_, null);
};
goog.inherits(proto.UT.PROTO.OhlcDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.OhlcDataResponse.displayName = 'proto.UT.PROTO.OhlcDataResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.UT.PROTO.OhlcDataResponse.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.OhlcDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.OhlcDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.OhlcDataResponse} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.OhlcDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    interval: jspb.Message.getFieldWithDefault(msg, 1, 0),
    symbolId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    instrumentName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    responseCategory: jspb.Message.getFieldWithDefault(msg, 4, 0),
    ohlcvListList: jspb.Message.toObjectList(msg.getOhlcvListList(),
    proto.UT.PROTO.OHLCV.toObject, includeInstance),
    isMarketMovementResponse: jspb.Message.getFieldWithDefault(msg, 6, false),
    responseid: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.OhlcDataResponse}
 */
proto.UT.PROTO.OhlcDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.OhlcDataResponse;
  return proto.UT.PROTO.OhlcDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.OhlcDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.OhlcDataResponse}
 */
proto.UT.PROTO.OhlcDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.UT.PROTO.OhlcInterval} */ (reader.readEnum());
      msg.setInterval(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSymbolId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstrumentName(value);
      break;
    case 4:
      var value = /** @type {!proto.UT.PROTO.OhlcDataResponseCategory} */ (reader.readEnum());
      msg.setResponseCategory(value);
      break;
    case 5:
      var value = new proto.UT.PROTO.OHLCV;
      reader.readMessage(value,proto.UT.PROTO.OHLCV.deserializeBinaryFromReader);
      msg.addOhlcvList(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMarketMovementResponse(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setResponseid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.OhlcDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.OhlcDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.OhlcDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.OhlcDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSymbolId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getInstrumentName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getResponseCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getOhlcvListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.UT.PROTO.OHLCV.serializeBinaryToWriter
    );
  }
  f = message.getIsMarketMovementResponse();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getResponseid();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional OhlcInterval interval = 1;
 * @return {!proto.UT.PROTO.OhlcInterval}
 */
proto.UT.PROTO.OhlcDataResponse.prototype.getInterval = function() {
  return /** @type {!proto.UT.PROTO.OhlcInterval} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.UT.PROTO.OhlcInterval} value */
proto.UT.PROTO.OhlcDataResponse.prototype.setInterval = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional int64 symbol_id = 2;
 * @return {number}
 */
proto.UT.PROTO.OhlcDataResponse.prototype.getSymbolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.UT.PROTO.OhlcDataResponse.prototype.setSymbolId = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional string instrument_name = 3;
 * @return {string}
 */
proto.UT.PROTO.OhlcDataResponse.prototype.getInstrumentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.UT.PROTO.OhlcDataResponse.prototype.setInstrumentName = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * optional OhlcDataResponseCategory response_category = 4;
 * @return {!proto.UT.PROTO.OhlcDataResponseCategory}
 */
proto.UT.PROTO.OhlcDataResponse.prototype.getResponseCategory = function() {
  return /** @type {!proto.UT.PROTO.OhlcDataResponseCategory} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {!proto.UT.PROTO.OhlcDataResponseCategory} value */
proto.UT.PROTO.OhlcDataResponse.prototype.setResponseCategory = function(value) {
  jspb.Message.setField(this, 4, value);
};


/**
 * repeated OHLCV ohlcv_list = 5;
 * If you change this array by adding, removing or replacing elements, or if you
 * replace the array itself, then you must call the setter to update it.
 * @return {!Array.<!proto.UT.PROTO.OHLCV>}
 */
proto.UT.PROTO.OhlcDataResponse.prototype.getOhlcvListList = function() {
  return /** @type{!Array.<!proto.UT.PROTO.OHLCV>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.UT.PROTO.OHLCV, 5));
};


/** @param {!Array.<!proto.UT.PROTO.OHLCV>} value */
proto.UT.PROTO.OhlcDataResponse.prototype.setOhlcvListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.UT.PROTO.OHLCV=} opt_value
 * @param {number=} opt_index
 * @return {!proto.UT.PROTO.OHLCV}
 */
proto.UT.PROTO.OhlcDataResponse.prototype.addOhlcvList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.UT.PROTO.OHLCV, opt_index);
};


proto.UT.PROTO.OhlcDataResponse.prototype.clearOhlcvListList = function() {
  this.setOhlcvListList([]);
};


/**
 * optional bool is_market_movement_response = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.UT.PROTO.OhlcDataResponse.prototype.getIsMarketMovementResponse = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.UT.PROTO.OhlcDataResponse.prototype.setIsMarketMovementResponse = function(value) {
  jspb.Message.setField(this, 6, value);
};


/**
 * optional int64 responseId = 7;
 * @return {number}
 */
proto.UT.PROTO.OhlcDataResponse.prototype.getResponseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.UT.PROTO.OhlcDataResponse.prototype.setResponseid = function(value) {
  jspb.Message.setField(this, 7, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.OhlcDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.OhlcDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.OhlcDataRequest.displayName = 'proto.UT.PROTO.OhlcDataRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.OhlcDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.OhlcDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.OhlcDataRequest} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.OhlcDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    interval: jspb.Message.getFieldWithDefault(msg, 1, 0),
    symbolId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    instrumentName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    startTimestamp: jspb.Message.getFieldWithDefault(msg, 4, 0),
    endTimestamp: jspb.Message.getFieldWithDefault(msg, 5, 0),
    isMarketMovementRequest: jspb.Message.getFieldWithDefault(msg, 6, false),
    requestId: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.OhlcDataRequest}
 */
proto.UT.PROTO.OhlcDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.OhlcDataRequest;
  return proto.UT.PROTO.OhlcDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.OhlcDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.OhlcDataRequest}
 */
proto.UT.PROTO.OhlcDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.UT.PROTO.OhlcInterval} */ (reader.readEnum());
      msg.setInterval(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSymbolId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstrumentName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartTimestamp(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndTimestamp(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsMarketMovementRequest(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.OhlcDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.OhlcDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.OhlcDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.OhlcDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInterval();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSymbolId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getInstrumentName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStartTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getEndTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getIsMarketMovementRequest();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getRequestId();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional OhlcInterval interval = 1;
 * @return {!proto.UT.PROTO.OhlcInterval}
 */
proto.UT.PROTO.OhlcDataRequest.prototype.getInterval = function() {
  return /** @type {!proto.UT.PROTO.OhlcInterval} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.UT.PROTO.OhlcInterval} value */
proto.UT.PROTO.OhlcDataRequest.prototype.setInterval = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional int64 symbol_id = 2;
 * @return {number}
 */
proto.UT.PROTO.OhlcDataRequest.prototype.getSymbolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.UT.PROTO.OhlcDataRequest.prototype.setSymbolId = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional string instrument_name = 3;
 * @return {string}
 */
proto.UT.PROTO.OhlcDataRequest.prototype.getInstrumentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.UT.PROTO.OhlcDataRequest.prototype.setInstrumentName = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * optional int64 start_timestamp = 4;
 * @return {number}
 */
proto.UT.PROTO.OhlcDataRequest.prototype.getStartTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.UT.PROTO.OhlcDataRequest.prototype.setStartTimestamp = function(value) {
  jspb.Message.setField(this, 4, value);
};


/**
 * optional int64 end_timestamp = 5;
 * @return {number}
 */
proto.UT.PROTO.OhlcDataRequest.prototype.getEndTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.UT.PROTO.OhlcDataRequest.prototype.setEndTimestamp = function(value) {
  jspb.Message.setField(this, 5, value);
};


/**
 * optional bool is_market_movement_request = 6;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.UT.PROTO.OhlcDataRequest.prototype.getIsMarketMovementRequest = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 6, false));
};


/** @param {boolean} value */
proto.UT.PROTO.OhlcDataRequest.prototype.setIsMarketMovementRequest = function(value) {
  jspb.Message.setField(this, 6, value);
};


/**
 * optional int64 request_id = 7;
 * @return {number}
 */
proto.UT.PROTO.OhlcDataRequest.prototype.getRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.UT.PROTO.OhlcDataRequest.prototype.setRequestId = function(value) {
  jspb.Message.setField(this, 7, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.Snapshot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.Snapshot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.Snapshot.displayName = 'proto.UT.PROTO.Snapshot';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.Snapshot.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.Snapshot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.Snapshot} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.Snapshot.toObject = function(includeInstance, msg) {
  var f, obj = {
    topBid: jspb.Message.getFieldWithDefault(msg, 1, 0),
    topAsk: jspb.Message.getFieldWithDefault(msg, 2, 0),
    timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.Snapshot}
 */
proto.UT.PROTO.Snapshot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.Snapshot;
  return proto.UT.PROTO.Snapshot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.Snapshot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.Snapshot}
 */
proto.UT.PROTO.Snapshot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTopBid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTopAsk(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.Snapshot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.Snapshot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.Snapshot} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.Snapshot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTopBid();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTopAsk();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 top_bid = 1;
 * @return {number}
 */
proto.UT.PROTO.Snapshot.prototype.getTopBid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.Snapshot.prototype.setTopBid = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional int64 top_ask = 2;
 * @return {number}
 */
proto.UT.PROTO.Snapshot.prototype.getTopAsk = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.UT.PROTO.Snapshot.prototype.setTopAsk = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional int64 timestamp = 3;
 * @return {number}
 */
proto.UT.PROTO.Snapshot.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.UT.PROTO.Snapshot.prototype.setTimestamp = function(value) {
  jspb.Message.setField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.SnapshotDataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.UT.PROTO.SnapshotDataResponse.repeatedFields_, null);
};
goog.inherits(proto.UT.PROTO.SnapshotDataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.SnapshotDataResponse.displayName = 'proto.UT.PROTO.SnapshotDataResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.UT.PROTO.SnapshotDataResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.SnapshotDataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.SnapshotDataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.SnapshotDataResponse} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.SnapshotDataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    symbolId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    instrumentName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    responseCategory: jspb.Message.getFieldWithDefault(msg, 3, 0),
    snapshotListList: jspb.Message.toObjectList(msg.getSnapshotListList(),
    proto.UT.PROTO.Snapshot.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.SnapshotDataResponse}
 */
proto.UT.PROTO.SnapshotDataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.SnapshotDataResponse;
  return proto.UT.PROTO.SnapshotDataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.SnapshotDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.SnapshotDataResponse}
 */
proto.UT.PROTO.SnapshotDataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSymbolId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstrumentName(value);
      break;
    case 3:
      var value = /** @type {!proto.UT.PROTO.SnapshotDataResponseCategory} */ (reader.readEnum());
      msg.setResponseCategory(value);
      break;
    case 4:
      var value = new proto.UT.PROTO.Snapshot;
      reader.readMessage(value,proto.UT.PROTO.Snapshot.deserializeBinaryFromReader);
      msg.addSnapshotList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.SnapshotDataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.SnapshotDataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.SnapshotDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.SnapshotDataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbolId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getInstrumentName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResponseCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSnapshotListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.UT.PROTO.Snapshot.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 symbol_id = 1;
 * @return {number}
 */
proto.UT.PROTO.SnapshotDataResponse.prototype.getSymbolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.SnapshotDataResponse.prototype.setSymbolId = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional string instrument_name = 2;
 * @return {string}
 */
proto.UT.PROTO.SnapshotDataResponse.prototype.getInstrumentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.UT.PROTO.SnapshotDataResponse.prototype.setInstrumentName = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional SnapshotDataResponseCategory response_category = 3;
 * @return {!proto.UT.PROTO.SnapshotDataResponseCategory}
 */
proto.UT.PROTO.SnapshotDataResponse.prototype.getResponseCategory = function() {
  return /** @type {!proto.UT.PROTO.SnapshotDataResponseCategory} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {!proto.UT.PROTO.SnapshotDataResponseCategory} value */
proto.UT.PROTO.SnapshotDataResponse.prototype.setResponseCategory = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * repeated Snapshot snapshot_list = 4;
 * If you change this array by adding, removing or replacing elements, or if you
 * replace the array itself, then you must call the setter to update it.
 * @return {!Array.<!proto.UT.PROTO.Snapshot>}
 */
proto.UT.PROTO.SnapshotDataResponse.prototype.getSnapshotListList = function() {
  return /** @type{!Array.<!proto.UT.PROTO.Snapshot>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.UT.PROTO.Snapshot, 4));
};


/** @param {!Array.<!proto.UT.PROTO.Snapshot>} value */
proto.UT.PROTO.SnapshotDataResponse.prototype.setSnapshotListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.UT.PROTO.Snapshot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.UT.PROTO.Snapshot}
 */
proto.UT.PROTO.SnapshotDataResponse.prototype.addSnapshotList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.UT.PROTO.Snapshot, opt_index);
};


proto.UT.PROTO.SnapshotDataResponse.prototype.clearSnapshotListList = function() {
  this.setSnapshotListList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.SnapshotDataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.SnapshotDataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.SnapshotDataRequest.displayName = 'proto.UT.PROTO.SnapshotDataRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.SnapshotDataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.SnapshotDataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.SnapshotDataRequest} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.SnapshotDataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    symbolId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    instrumentName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    startTimestamp: jspb.Message.getFieldWithDefault(msg, 3, 0),
    endTimestamp: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.SnapshotDataRequest}
 */
proto.UT.PROTO.SnapshotDataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.SnapshotDataRequest;
  return proto.UT.PROTO.SnapshotDataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.SnapshotDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.SnapshotDataRequest}
 */
proto.UT.PROTO.SnapshotDataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSymbolId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstrumentName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartTimestamp(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.SnapshotDataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.SnapshotDataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.SnapshotDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.SnapshotDataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbolId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getInstrumentName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStartTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getEndTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional int64 symbol_id = 1;
 * @return {number}
 */
proto.UT.PROTO.SnapshotDataRequest.prototype.getSymbolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.SnapshotDataRequest.prototype.setSymbolId = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional string instrument_name = 2;
 * @return {string}
 */
proto.UT.PROTO.SnapshotDataRequest.prototype.getInstrumentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.UT.PROTO.SnapshotDataRequest.prototype.setInstrumentName = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional int64 start_timestamp = 3;
 * @return {number}
 */
proto.UT.PROTO.SnapshotDataRequest.prototype.getStartTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.UT.PROTO.SnapshotDataRequest.prototype.setStartTimestamp = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * optional int64 end_timestamp = 4;
 * @return {number}
 */
proto.UT.PROTO.SnapshotDataRequest.prototype.getEndTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.UT.PROTO.SnapshotDataRequest.prototype.setEndTimestamp = function(value) {
  jspb.Message.setField(this, 4, value);
};


goog.object.extend(exports, proto.UT.PROTO);
